import { render } from "./QuizRetry.vue?vue&type=template&id=4077b5b2&scoped=true&ts=true"
import script from "./QuizRetry.vue?vue&type=script&lang=ts"
export * from "./QuizRetry.vue?vue&type=script&lang=ts"

import "./QuizRetry.vue?vue&type=style&index=0&id=4077b5b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4077b5b2"]])

export default __exports__